import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from '../team_probeach/team_probeach.module.scss';
import logo from '../team_probeach/src/logo.png';

const Team_probeach: React.FC = () => {
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.team_probeach}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={styles["container-thunder"]}>
                    <div className={styles.links}>
                        <a
                            href="https://wa.me/5516991207617?text=Olá, gostaria de agendar uma aula."
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Aula experimental</span>
                        </a>
                        <Link to="/team_probeach/horarios" className={styles.linkGradient}>
                            <span>Horários</span>
                        </Link>
                        <Link to="/team_probeach/valores" className={styles.linkGradient}>
                            <span>Valores</span>
                        </Link>
                        <a
                            href="https://www.instagram.com/team_probeach?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw=="
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Instagram</span>
                        </a>
                        <a
                            href="https://maps.app.goo.gl/6K3uJRAeNxnRQVVF8"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Localização</span>
                        </a>
                    </div>
                    <img src={logo} alt="Pro Beach — Vôlei de Praia" className={styles.logo} />
                </div>
            </div>
        </div>
    );
};

export default Team_probeach;
